const domainActionLoadingMessages = {
    add: 'Adding domains...',
    changeType: 'Changing domain type...',
    remove: 'Removing domains...',
    undefined: 'Loading...',
};

export default domainActionLoadingMessages;
